var vrpFilterShowing = false
var skrollrInstance = false
jQuery(function ($) {
  
  isMobile = {
    Android: function () {
      return !!navigator.userAgent.match(/Android/i)
    },
    BlackBerry: function () {
      return !!navigator.userAgent.match(/BlackBerry/i)
    },
    iOS: function () {
      return !!navigator.userAgent.match(/iPhone|iPad|iPod/i)
    },
    Windows: function () {
      return !!navigator.userAgent.match(/IEMobile/i)
    },
    any: function () {
      return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Windows() || $(window).width() < 767)
    },
    tablet: function () {
      return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Windows()) && $(window).width() > 767
    }
  }

  if ($('.sidebar-navigation-enabled').length > 0) {
    var mobile_nav_menu_width = isMobile.tablet() ? '240' : '260'// $("#sidr").width();
    var whichSideMobileClass = $('.mobile-menu-toggle').data('side') || 'left'
    var whichSideMobileID = $('#mobile-menu-toggle').data('side') || 'left'
    var whichSideDesktop = $('#desktop-menu-toggle').data('side') || 'left'

    var mobileClassSidrContainer = $('.mobile-menu-toggle').data('container') || 'sidr'
    var mobileIDSidrContainer = $('#mobile-menu-toggle').data('container') || 'sidr'
    var desktopSidrContainer = $('#desktop-menu-toggle').data('container') || 'sidr'
    var $sidrCloseTargets = $('.contentcontainer,.close-mobile-nav,.close-mobile-wrap,#mobile-advanced-search')

    $('.mobile-menu-toggle').sidr({
      name: mobileClassSidrContainer,
      side: whichSideMobileClass,
      onOpen: function () {
        var animOpts = {}
        animOpts[whichSideMobileClass] = '+=' + mobile_nav_menu_width
        $('.menu-top').animate(animOpts, 200)
        if (whichSideMobileClass == 'right') {
          $('.menu-top').css({'left': 'auto'})
        }
      },
      onClose: function () {
        var animOpts = {}
        animOpts[whichSideMobileClass] = '-=' + mobile_nav_menu_width
        $('.menu-top').animate(animOpts, 200)
        if (whichSideMobileClass == 'right') {
          $('.menu-top').css({'left': 'auto'})
        }
      }
    })

    // b/o: close sidr when body is tapped on mobile
    $sidrCloseTargets.bind('click', function () {
      $.sidr('close', mobileClassSidrContainer)
    })
    // e/o: close sidr when body is tapped on mobile

    $('#mobile-menu-toggle').sidr({
      name: mobileIDSidrContainer,
      side: whichSideMobileID,
      onOpen: function () {
        var animOpts = {}
        animOpts[whichSideMobileID] = '+=' + mobile_nav_menu_width
        $('.menu-top').animate(animOpts, 200)
        if (whichSideMobileID == 'right') {
          $('.menu-top').css({'left': 'auto'})
        }
      },
      onClose: function () {
        var animOpts = {}
        animOpts[whichSideMobileID] = '-=' + mobile_nav_menu_width
        $('.menu-top').animate(animOpts, 200)
        if (whichSideMobileID == 'right') {
          $('.menu-top').css({'left': 'auto'})
        }
      }
    })

    // b/o: close sidr when body is tapped on mobile
    $sidrCloseTargets.bind('click', function () {
      $.sidr('close', mobileIDSidrContainer)
    })
    // e/o: close sidr when body is tapped on mobile

    $('#desktop-menu-toggle').sidr({
      name: desktopSidrContainer,
      side: whichSideDesktop,
      onOpen: function () {
        var animOpts = {}
        animOpts[whichSideDesktop] = '+=' + mobile_nav_menu_width
        $('.menu-top').animate(animOpts, 200)
        if (whichSideDesktop == 'right') {
          $('.menu-top').css({'left': 'auto'})
        }
      },
      onClose: function () {
        var animOpts = {}
        animOpts[whichSideDesktop] = '-=' + mobile_nav_menu_width
        $('.menu-top').animate(animOpts, 200)
        if (whichSideDesktop == 'right') {
          $('.menu-top').css({'left': 'auto'})
        }
      }
    })

    // b/o: close sidr when body is tapped on mobile
    $sidrCloseTargets.bind('click', function () {
      $.sidr('close', desktopSidrContainer)
    })
    // e/o: close sidr when body is tapped on mobile
  } else {
    // MOBILE DROP DOWN MENU
    $(document).on('click tab', '#mobile-menu-toggle', function (e) {
      e.preventDefault()

      var overflow = $('body').css('overflow')
      $('.mobile-nav-menu').toggle({
        easing: 'easeInOutBack'
      })
      if (overflow == 'hidden') {
        $('body').css('overflow', 'visible')
      } else {
        $('body').css('overflow', 'hidden')
      }
    })
  }

  // cross-browser placeholder
  $('input, textarea').placehold()

    // Clear form defaults when active/focus
  $.fn.cleardefault = function () {
    return this.focus(function () {
      if (this.value === this.defaultValue) {
        this.value = ''
      }
    }).blur(function () {
      if (!this.value.length) {
        this.value = this.defaultValue
      }
    })
  }
  // But don't do it on buttons!!
  $('.clearit input:not(:input[type=submit]), .clearit textarea').cleardefault()

  // Clicky Tracking Link Additions
  var title = (document.title)
  $('li.apply a, li.rebates a, li.value a, a.preApproved,a.testDrive,a.reserveVehicle,a.emailicon,a.smallgreenbutton,input#searchsubmit').each(function () {
    var btntext = $(this).text()
    $(this).attr({'onclick': "clicky.log(this.href,'" + title + '-' + btntext + "');"})
  })

  // PLACE THE CURSOR in the search box by default
  if (!isMobile.any()) {
    $('#searchform #s').focus()
  }

  // Turn on Owl Carousel for Models
  if ($('#modelcarousel.five').length > 0) {
    var owlModels5 = $('#modelcarousel').owlCarousel({
      autoPlay: 7000,
      navigation: true,
      items: 5,
      itemsDesktop: [1024, 4],
      itemsDesktopSmall: [979, 4],
      itemsTablet: [768, 3],
      itemsMobile: [320, 2]
    })
  } else if ($('#modelcarousel').length > 0) {
    var owlModels = $('#modelcarousel').owlCarousel({
      autoPlay: 7000,
      navigation: true,
      items: 6,
      itemsDesktop: [1024, 5],
      itemsDesktopSmall: [979, 5],
      itemsTablet: [768, 4],
      itemsMobile: [320, 2]
    })
  }

  // Fancybox - Lightbox
  if (!isMobile.any() || isMobile.tablet()) { // Only trigger the lightbox if it's not mobile
    $('.lightbox').fancybox({
      maxWidth: 800,
      maxHeight: 600,
      fitToView: false,
      width: '70%',
      height: '70%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none'
    })
  }

  // Fancybox - Lightbox for Vehicle Form Popup
  if (!isMobile.any() || isMobile.tablet()) { // Only trigger the lightbox if it's not mobile
    $('.lightbox-form').fancybox({
      maxWidth: 800,
      maxHeight: 600,
      fitToView: false,
      width: '70%',
      height: '70%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      beforeLoad: function () {
        var clickID = $(this.element).attr('id')
        var stocknum = $('#' + clickID + ' span.stocknum').text()
        var model = $('#' + clickID + ' span.model').text()
        var make = $('#' + clickID + ' span.make').text()
        var year = $('#' + clickID + ' span.year').text()
        $('li.stocknum input').attr('value', stocknum)
        $('li.model input').attr('value', model)
        $('li.year input').attr('value', year)
        $('li.make input').attr('value', make)
      }
    })
  }

  $('.fancy_print').click(function () {
    var couponID = $(this).parents('.printSection').attr('data-attribute-printid')
    printIt(document.getElementById(couponID).innerHTML)
  })

  var win = null
  function printIt (printThis) {

    var docType = '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN"  "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">'
    var disp_setting = 'toolbar=yes,location=no,directories=yes,menubar=yes,scrollbars=yes,width=800, height=800, left=50, top=25,_blank'
    if (navigator.appName != 'Microsoft Internet Explorer') { disp_setting = '' }

    var defaultPrintStyles = 'body{ font-family: Arial; font-size: 12pt;} .expires {font-style: italic; margin: 5px 0;} .modelName {color:blue;font-size:16pt;margin: 5px 0;} .disclaimer {font-size:10pt; font-style: italic;color: gray;}';

    var customDealerPrintStyles = (typeof dealer_custom === "object" && typeof dealer_custom.printStyles) ? dealer_custom['printStyles'] : '';

    var styles = defaultPrintStyles + customDealerPrintStyles;

    var win = window.open('', '', disp_setting)
    win.document.open()
    win.document.write(docType)
    win.document.write('<head><title></title>')
    win.document.write('<head><style>')
    win.document.write( styles )
    win.document.write('</style>')
    win.document.write('</head><body onLoad="self.print();">')
    win.document.write(printThis)
    win.document.write('</body></html>')
    win.document.close()
    win.focus()
  }

  $('button.print').click(function () {
    window.focus()
    window.print()
  })

  if (isMobile.any() && !isMobile.tablet()) { // hide cta box on mobile
    $('.cta-box').hide()
  }

  // Add YouTube Lightbox Functionality to SLIDER
  $('#flexslider_hg_homepage ul.slides li a').each(function () {
    var slide_link = $(this).attr('href')

    if (slide_link && slide_link.indexOf('youtube.com') >= 1) {
      $(this).addClass('youtube-lightbox')
      $(this).click(function (e) {
        e.preventDefault()
        $.fancybox({
          'padding': 0,
          'autoScale': false,
          'transitionIn': 'none',
          'transitionOut': 'none',
          'title': this.title,
          'width': 680,
          'height': 495,
          'href': this.href.replace(new RegExp('watch\\?v=', 'i'), 'v/'),
          'type': 'swf',
          'swf': {
            'wmode': 'transparent',
            'allowfullscreen': 'true'
          }
        })
        return false
      })
    }
  })

  /** *** MENUS *****/

  // Sticky Navigation

  // Calculate the height of <header>
  var aboveHeight = $('.header-container').outerHeight()

  $(window).scroll(function () {
    // if scrolled down more than the headerâ€™s height but this isn't mobile
    if ($(window).scrollTop() > aboveHeight && !$(window).width() < 767) {
      // if yes, add fixed class to the <nav>
      // add padding top to the #content
      $('.navigation-container:not(#nostick)').addClass('fixed').css('top', '0').next().css('padding-top', '40px')
    } else {
      $('.navigation-container:not(#nostick)').removeClass('fixed').next().css('padding-top', '0')
    }
  })

  $('.accordion, #accordionMenu').accordion({
    active: false,
    collapsible: true,
    heightStyle: 'content',
    icons: icons,
    beforeActivate: function (event, ui) {
      try {
        $e = jQuery(ui.newHeader.context).find('a')
        if ($e.length > 0 && $e.is('.fancy,.fancy_iframe,.fancybox,.lightbox') === true) { return false }
      } catch (e) {
        if (typeof console !== 'undefined') { console.log(e.stack) }

        return true
      }
    }
  })

  if (isMobile.any()) {
    $('body').css({overflowX: 'hidden'})

    $('#model-listing-toggle').click(function (e) {
      $('.model-listing').toggle()
    })

    $('#brands-listing-toggle').click(function (e) {
      $('.brand-listing').toggle()
    })

    var icons = {
      header: 'ui-icon-plus',
      activeHeader: 'ui-icon-minus'
    }

    $('#cta-mobile-button').on('click', function () {
      $('.mobile-action-form.open').removeClass('open')
      $(this).parent().find('.mobile-action-form').addClass('open')
    })

    $('.mobile-action-close').on('click', function () {
      $('.mobile-action-form.open').removeClass('open')
    })

    jQuery('#main-action-form-mobile').find('label').each(function (i, el) {
      jQuery(el).parent().find('input,textarea').each(function (j, inp) {
        jQuery(inp).attr('placeholder', jQuery(el).text())
      })
    })

    if ($('.vrp-listing').length > 0) {
      jQuery('a.vrp-incentives').fancybox()
      jQuery('#vrp-filter-menu').show()

      jQuery('.filters').click(function (e) {
        e.stopPropagation()
      })
    }
  }// end if mobile

  $('#view-desktop-site').click(function (e) {
    e.preventDefault()

    var expires = 60 * 60 * 1000 // 1 hour
    document.cookie = 'view-desktop=yes; expires=' + expires + '; path=/'

    var query = window.location.search, viewDesktop = 'view-desktop=yes'

    query += (query === '' ? '?' : '&') + viewDesktop

    window.location.search = query // page should reload
  })

  // popovers for more-actions on VDP
  $('.maincardetails .more-action div').popover({
    placement: 'top',
    trigger: 'hover'
  })

  // remove scroller header for tablet
  if (isMobile.tablet()) {
    $('#whitewrap').addClass('tablet')
    $('.touch-header .menu-top').css('top', '0px')
    $('.touch-header .menu-top').removeAttr('data-0')
    $('.touch-header .menu-top').removeAttr('data-40')
  }

  jQuery(function () {
    function gotoDate ($j, month, year) {
      $j.each(function (i, el) {
        var inst = $.datepicker._getInst(el)
        inst.drawMonth = inst.selectedMonth = month
        inst.drawYear = inst.selectedYear = year
        $.datepicker._notifyChange(inst)
        $.datepicker._adjustDate(el)
      })
    }

    function setStrictBeforeShowOptions(el, obj) {
      jQuery(el).attr('readonly', 'readonly');

      if (! jQuery(el).parent().find('.gf-date-clear').length) {
        jQuery(el).parent().append('<p class="gf-date-clear" style="margin-top:-10px;margin-left:5px;"><a href="#">clear date</small></p>');
      }

      jQuery(el).parents('.gfield').find('.gf-date-clear a').on('click', function() {
        $(this).parents('.ginput_container_date').find('.datepicker').val('');
        $(this).parents('.ginput_container_date').find('.gf-date-clear').remove();
        return false;
      });

    }

    /*
    Gravity Forms code for pages with only 1 Gravity Form. For multiple forms on a page use application.js, but it's probably wise to put the code in both spots
     */
    if (jQuery('.gfield.noweekends').length > 0) {
      // destroy default Gravity Form datepicker
      jQuery('.gfield.noweekends .datepicker').datepicker('destroy')
      // create new custom datepicker
      jQuery('.gfield.noweekends .datepicker').datepicker({
        minDate: '+1',
        showOn: 'both',
        buttonImage: '/wp-content/plugins/gravityforms/images/calendar.png',
        buttonImageOnly: true,
        beforeShow: function(el, obj) {
          setStrictBeforeShowOptions(el, obj);
        },
        beforeShowDay: jQuery.datepicker.noWeekends
      })
    } else if (jQuery('.gfield.nosundays').length > 0) {
      // destroy default Gravity Form datepicker
      jQuery('.gfield.nosundays .datepicker').datepicker('destroy')
      // create new custom datepicker
      jQuery('.gfield.nosundays .datepicker').datepicker({
        minDate: '+1',
        showOn: 'both',
        buttonImage: '/wp-content/plugins/gravityforms/images/calendar.png',
        buttonImageOnly: true,
        beforeShow: function(el, obj) {
          setStrictBeforeShowOptions(el, obj);
        },
        beforeShowDay: function (date) {
          var day = date.getDay()
          return [(day != 0)]
        }
      })
    } else if (jQuery('.gfield.nosaturdays').length > 0) {
      // destroy default Gravity Form datepicker
      jQuery('.gfield.nosaturdays .datepicker').datepicker('destroy')
      // create new custom datepicker
      jQuery('.gfield.nosaturdays .datepicker').datepicker({
        minDate: '+1',
        showOn: 'both',
        buttonImage: '/wp-content/plugins/gravityforms/images/calendar.png',
        buttonImageOnly: true,
        beforeShow: function(el, obj) {
          setStrictBeforeShowOptions(el, obj);
        },
        beforeShowDay: function (date) {
          var day = date.getDay()
          return [(day != 6)]
        }
      })

      jQuery('.gfield.nosaturdays .datepicker').attr('readonly', 'readonly');
      jQuery('.gfield.nosaturdays .datepicker').after('<p class="gf-date-clear" style="margin-top:-10px;margin-left:5px;"><a href="#">clear date</small></p>');
      jQuery('.gfield.nosaturdays .gf-date-clear a').on('click', function() {
        $(this).parents('.ginput_container_date').find('.datepicker').val('');
        return false;
      });
    } else if (jQuery('.gfield.di_gf_enable_today').length > 0) {
      var todaysDate = new Date()
      // destroy default Gravity Form datepicker
      jQuery('.gfield.di_gf_enable_today .datepicker').datepicker('destroy')
      // create new custom datepicker
      jQuery('.gfield.di_gf_enable_today .datepicker').datepicker({
        minDate: todaysDate,
        showOn: 'both',
        buttonImage: '/wp-content/plugins/gravityforms/images/calendar.png',
        buttonImageOnly: true
      })
    } else if (jQuery('.gfield.nofridayWeekends').length > 0) {
      // destroy default Gravity Form datepicker
      jQuery('.gfield.nofridayWeekends .datepicker').datepicker('destroy')
      // create new custom datepicker
      jQuery('.gfield.nofridayWeekends .datepicker').datepicker({
        minDate: '+1',
        showOn: 'both',
        buttonImage: '/wp-content/plugins/gravityforms/images/calendar.png',
        buttonImageOnly: true,
        beforeShow: function(el, obj) {
          setStrictBeforeShowOptions(el, obj);
        },
        beforeShowDay: function (date) {
          var day = date.getDay();
          if( (day == 5) || (day == 6)  || (day == 0) ){
            return [false, ''];
          }
          else
            return [true, ''];
        }
      })
    }
    else {
      // only affect non multistep forms
      if (!jQuery('.gfield .datepicker').parents('.gform_page').length) {
                // destroy default Gravity Form datepicker
        jQuery('.gfield .datepicker').datepicker('destroy')

          // create new custom datepicker
        jQuery('.gfield .datepicker').datepicker({
          minDate: '+1',
          showOn: 'both',
          buttonImage: '/wp-content/plugins/gravityforms/images/calendar.png',
          buttonImageOnly: true
        })
      }

      /* WARNING - WARNING -- This code is also located in application.js for multiple Gravity Forms
         * so if you update the code here, you have to replicate it in application.js
         *
             * Set custom minDate options using static classes in the wp-admin > GF > Form editor
             * This will disable the amount of days including todays date
             * YOU MUST ALSO ADD datepicker AS A CLASS FOR THE DATEPICKER FIELD, AS WELL AS THE di_gf_plus_xd
             * So the class input box would look like this: datepicker di_gf_plus_3d
             */
            // if the datepicker parent has the .di_gf_plus_1d class, then disable todays date

      // enable past dates
      if (jQuery('.gfield.di_past_dates .datepicker').length) {
        jQuery('.gfield.di_past_dates .datepicker').datepicker('option', 'minDate', null);
      }

      if (jQuery('.gfield.di_gf_plus_1d .datepicker').length) {
        jQuery('.gfield.di_gf_plus_1d .datepicker').datepicker('option', 'minDate', '+1d')

        if (jQuery('.gfield.di_gf_plus_1d').hasClass('nosundays')) {
          jQuery('.gfield.di_gf_plus_1d .datepicker').datepicker('option', 'beforeShowDay', noSunday)
        }

        if (jQuery('.gfield.di_gf_plus_1d').hasClass('nosaturdays')) {
          jQuery('.gfield.di_gf_plus_1d .datepicker').datepicker('option', 'beforeShowDay', noSaturday)
        }

        if (jQuery('.gfield.di_gf_plus_1d').hasClass('nofridayWeekends')) {
          jQuery('.gfield.di_gf_plus_1d .datepicker').datepicker('option', 'beforeShowDay', noFridayWeekend)
        }

        if (jQuery('.gfield.di_gf_plus_1d').hasClass('noweekends')) {
          jQuery('.gfield.di_gf_plus_1d.noweekends .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
        }

              /* skip weekends on blackout dates - so if the 1st day falls on a Sunday, blackout Monday */
        if (jQuery('.gfield.di_gf_plus_1d').hasClass('blackoutskipweekends')) {
          var oneWorkingDay = new Date()
          var adjustments = [0, 0, 2, 2, 2, 2, 1] // Offsets by day of the week
          oneWorkingDay.setDate(oneWorkingDay.getDate() + 1 + adjustments[oneWorkingDay.getDay()])
          $('.gfield.di_gf_plus_1d .datepicker').datepicker('option', 'minDate', oneWorkingDay)
          $('.gfield.di_gf_plus_1d .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
        }
      }

            // if the datepicker parent has the .di_gf_plus_2d class, then disable today, and next day
      if (jQuery('.gfield.di_gf_plus_2d .datepicker').length) {
        jQuery('.gfield.di_gf_plus_2d .datepicker').datepicker('option', 'minDate', '+2d')

        if (jQuery('.gfield.di_gf_plus_2d').hasClass('nosundays')) {
          jQuery('.gfield.di_gf_plus_2d .datepicker').datepicker('option', 'beforeShowDay', noSunday)
        }

        if (jQuery('.gfield.di_gf_plus_2d').hasClass('nosaturdays')) {
          jQuery('.gfield.di_gf_plus_2d .datepicker').datepicker('option', 'beforeShowDay', noSaturday)
        }

        if (jQuery('.gfield.di_gf_plus_2d').hasClass('nofridayWeekends')) {
          jQuery('.gfield.di_gf_plus_2d .datepicker').datepicker('option', 'beforeShowDay', noFridayWeekend)
        }

        if (jQuery('.gfield.di_gf_plus_2d').hasClass('noweekends')) {
          jQuery('.gfield.di_gf_plus_2d.noweekends .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
        }

              /* skip weekends on blackout dates - so if the 2nd day falls on a Sunday, blackout Monday */
        if (jQuery('.gfield.di_gf_plus_2d').hasClass('blackoutskipweekends')) {
          var twoWorkingDays = new Date()
          var adjustments = [0, 0, 2, 2, 2, 2, 1] // Offsets by day of the week
          twoWorkingDays.setDate(twoWorkingDays.getDate() + 2 + adjustments[twoWorkingDays.getDay()])
          $('.gfield.di_gf_plus_2d .datepicker').datepicker('option', 'minDate', twoWorkingDays)
          $('.gfield.di_gf_plus_2d .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
        }
      }

            // if the datepicker parent has the .di_gf_plus_3d class, then disable today, and the next 2 days
      if (jQuery('.gfield.di_gf_plus_3d .datepicker').length) {
        jQuery('.gfield.di_gf_plus_3d .datepicker').datepicker('option', 'minDate', '+3d')

        if (jQuery('.gfield.di_gf_plus_3d').hasClass('nosundays')) {
          jQuery('.gfield.di_gf_plus_3d .datepicker').datepicker('option', 'beforeShowDay', noSunday)
        }

        if (jQuery('.gfield.di_gf_plus_3d').hasClass('nosaturdays')) {
          jQuery('.gfield.di_gf_plus_3d .datepicker').datepicker('option', 'beforeShowDay', noSaturday)
        }

        if (jQuery('.gfield.di_gf_plus_3d').hasClass('nofridayWeekends')) {
          jQuery('.gfield.di_gf_plus_3d .datepicker').datepicker('option', 'beforeShowDay', noFridayWeekend)
        }

        if (jQuery('.gfield.di_gf_plus_3d').hasClass('noweekends')) {
          jQuery('.gfield.di_gf_plus_3d.noweekends .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
        }

              /* skip weekends on blackout dates - so if the 3rd day falls on a Sunday, blackout Monday */
        if (jQuery('.gfield.di_gf_plus_3d').hasClass('blackoutskipweekends')) {
          var threeWorkingDays = new Date()
          var adjustments = [0, 0, 2, 2, 2, 2, 1] // Offsets by day of the week
          threeWorkingDays.setDate(threeWorkingDays.getDate() + 3 + adjustments[threeWorkingDays.getDay()])
          $('.gfield.di_gf_plus_3d .datepicker').datepicker('option', 'minDate', threeWorkingDays)
          $('.gfield.di_gf_plus_3d .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
        }
      }

            // if the datepicker parent has the .di_gf_plus_4d class, then disable today, and the next 3 days
      if (jQuery('.gfield.di_gf_plus_4d .datepicker').length) {
        jQuery('.gfield.di_gf_plus_4d .datepicker').datepicker('option', 'minDate', '+4d')

        if (jQuery('.gfield.di_gf_plus_4d').hasClass('nosundays')) {
          jQuery('.gfield.di_gf_plus_4d .datepicker').datepicker('option', 'beforeShowDay', noSunday)
        }

        if (jQuery('.gfield.di_gf_plus_4d').hasClass('nosaturdays')) {
          jQuery('.gfield.di_gf_plus_4d .datepicker').datepicker('option', 'beforeShowDay', noSaturday)
        }

        if (jQuery('.gfield.di_gf_plus_4d').hasClass('nofridayWeekends')) {
          jQuery('.gfield.di_gf_plus_4d .datepicker').datepicker('option', 'beforeShowDay', noFridayWeekend)
        }

        if (jQuery('.gfield.di_gf_plus_4d').hasClass('noweekends')) {
          jQuery('.gfield.di_gf_plus_4d.noweekends .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
        }

              /* skip weekends on blackout dates - so if the 4th day falls on a Sunday, blackout Monday */
        if (jQuery('.gfield.di_gf_plus_4d').hasClass('blackoutskipweekends')) {
          var fourWorkingDays = new Date()
          var adjustments = [0, 0, 2, 2, 2, 2, 1] // Offsets by day of the week
          fourWorkingDays.setDate(fourWorkingDays.getDate() + 4 + adjustments[fourWorkingDays.getDay()])
          $('.gfield.di_gf_plus_4d.blackoutskipweekends .datepicker').datepicker('option', 'minDate', fourWorkingDays)
          $('.gfield.di_gf_plus_4d.blackoutskipweekends .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
        }
      }

            // if the datepicker parent has the .di_gf_plus_5d class, then disable today and the next 4 days
      if (jQuery('.gfield.di_gf_plus_5d .datepicker').length) {
        jQuery('.gfield.di_gf_plus_5d .datepicker').datepicker('option', 'minDate', '+5d')

        if (jQuery('.gfield.di_gf_plus_5d').hasClass('nosundays')) {
          jQuery('.gfield.di_gf_plus_5d .datepicker').datepicker('option', 'beforeShowDay', noSunday)
        }

        if (jQuery('.gfield.di_gf_plus_5d').hasClass('nosaturdays')) {
          jQuery('.gfield.di_gf_plus_5d .datepicker').datepicker('option', 'beforeShowDay', noSaturday)
        }

        if (jQuery('.gfield.di_gf_plus_5d').hasClass('nofridayWeekends')) {
          jQuery('.gfield.di_gf_plus_5d .datepicker').datepicker('option', 'beforeShowDay', noFridayWeekend)
        }

        if (jQuery('.gfield.di_gf_plus_5d').hasClass('noweekends')) {
          jQuery('.gfield.di_gf_plus_5d.noweekends .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
        }

              /* skip weekends on blackout dates - so if the 5th day falls on a Sunday, blackout Monday */
        if (jQuery('.gfield.di_gf_plus_5d').hasClass('blackoutskipweekends')) {
          var fiveWorkingDays = new Date()
          var adjustments = [2, 2, 2, 2, 2, 2, 1] // Offsets by day of the week
          fiveWorkingDays.setDate(fiveWorkingDays.getDate() + 5 + adjustments[fiveWorkingDays.getDay()])
          $('.gfield.di_gf_plus_5d .datepicker').datepicker('option', 'minDate', fiveWorkingDays)
          $('.gfield.di_gf_plus_5d .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
        }
      }

            // if the datepicker parent has the .di_gf_plus_6d class, then disable today and the next 5 days
      if (jQuery('.gfield.di_gf_plus_6d .datepicker').length) {
        jQuery('.gfield.di_gf_plus_6d .datepicker').datepicker('option', 'minDate', '+6d')

        if (jQuery('.gfield.di_gf_plus_6d').hasClass('nosundays')) {
          jQuery('.gfield.di_gf_plus_6d .datepicker').datepicker('option', 'beforeShowDay', noSunday)
        }

        if (jQuery('.gfield.di_gf_plus_6d').hasClass('nosaturdays')) {
          jQuery('.gfield.di_gf_plus_6d .datepicker').datepicker('option', 'beforeShowDay', noSaturday)
        }
        if (jQuery('.gfield.di_gf_plus_6d').hasClass('nofridayWeekends')) {
          jQuery('.gfield.di_gf_plus_6d .datepicker').datepicker('option', 'beforeShowDay', noFridayWeekend)
        }
        if (jQuery('.gfield.di_gf_plus_6d').hasClass('noweekends')) {
          jQuery('.gfield.di_gf_plus_6d.noweekends .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
        }

              /* skip weekends on blackout dates - so if the 6th day falls on a Sunday, blackout Monday */
        if (jQuery('.gfield.di_gf_plus_6d').hasClass('blackoutskipweekends')) {
          var sixWorkingDays = new Date()
          var adjustments = [2, 2, 2, 2, 2, 2, 1] // Offsets by day of the week
          sixWorkingDays.setDate(sixWorkingDays.getDate() + 6 + adjustments[sixWorkingDays.getDay()])
          $('.gfield.di_gf_plus_6d .datepicker').datepicker('option', 'minDate', sixWorkingDays)
          $('.gfield.di_gf_plus_6d .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
        }
      }

            // if the datepicker parent has the .di_gf_plus_7d class, then disable today and the next 6 days
      if (jQuery('.gfield.di_gf_plus_7d .datepicker').length) {
        jQuery('.gfield.di_gf_plus_7d .datepicker').datepicker('option', 'minDate', '+7d')

        if (jQuery('.gfield.di_gf_plus_7d').hasClass('nosundays')) {
          jQuery('.gfield.di_gf_plus_7d .datepicker').datepicker('option', 'beforeShowDay', noSunday)
        }

        if (jQuery('.gfield.di_gf_plus_7d').hasClass('nosaturdays')) {
          jQuery('.gfield.di_gf_plus_7d .datepicker').datepicker('option', 'beforeShowDay', noSaturday)
        }

        if (jQuery('.gfield.di_gf_plus_7d').hasClass('nofridayWeekends')) {
          jQuery('.gfield.di_gf_plus_7d .datepicker').datepicker('option', 'beforeShowDay', noFridayWeekend)
        }

        if (jQuery('.gfield.di_gf_plus_7d').hasClass('noweekends')) {
          jQuery('.gfield.di_gf_plus_7d.noweekends .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
        }

              /* skip weekends on blackout dates - so if the 7th day falls on a Sunday, blackout Monday */
        if (jQuery('.gfield.di_gf_plus_7d').hasClass('blackoutskipweekends')) {
          var sevenWorkingDays = new Date()
          var adjustments = [2, 2, 2, 2, 2, 2, 1] // Offsets by day of the week
          sevenWorkingDays.setDate(sevenWorkingDays.getDate() + 7 + adjustments[sevenWorkingDays.getDay()])
          $('.gfield.di_gf_plus_7d .datepicker').datepicker('option', 'minDate', sevenWorkingDays)
          $('.gfield.di_gf_plus_7d .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
        }
      }

      // if the datepicker parent has the .di_gf_plus_14d class, then disable today and the next 6 days
      if (jQuery('li.di_gf_plus_14d .datepicker').length) {
        jQuery('li.di_gf_plus_14d .datepicker').datepicker('option', 'minDate', '+14d')

        if (jQuery('li.di_gf_plus_14d').hasClass('nosundays')) {
          jQuery('li.di_gf_plus_14d .datepicker').datepicker('option', 'beforeShowDay', noSunday)
        }

        if (jQuery('li.di_gf_plus_14d').hasClass('nosaturdays')) {
          jQuery('li.di_gf_plus_14d .datepicker').datepicker('option', 'beforeShowDay', noSaturday)
        }

        if (jQuery('li.di_gf_plus_14d').hasClass('nofridayWeekends')) {
          jQuery('li.di_gf_plus_14d .datepicker').datepicker('option', 'beforeShowDay', noFridayWeekend)
        }

        if (jQuery('li.di_gf_plus_14d').hasClass('noweekends')) {
          jQuery('li.di_gf_plus_14d.noweekends .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
        }

        /* skip weekends on blackout dates - so if the 7th day falls on a Sunday, blackout Monday */
        if (jQuery('li.di_gf_plus_14d').hasClass('blackoutskipweekends')) {
          var sevenWorkingDays = new Date()
          var adjustments = [2, 2, 2, 2, 2, 2, 1] // Offsets by day of the week
          sevenWorkingDays.setDate(sevenWorkingDays.getDate() + 7 + adjustments[sevenWorkingDays.getDay()])
          $('li.di_gf_plus_14d .datepicker').datepicker('option', 'minDate', sevenWorkingDays)
          $('li.di_gf_plus_14d .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
        }
      }

      /**
       * Using start and end date class
       * Start Date: `sd|2017-09-01`
       * End Date (if applicable): `ed|2017-09-03`
       */
      // Define a start date
      if ($('li[class*="sd|"] .datepicker').length) {
        var dateClass = $('li[class*="sd|"] .datepicker').parents('li[class*="sd|"]').attr('class'),
          _date = dateClass.match(/sd\|([^\s]*)/),
          startDate = new Date(_date[1])

        $('li[class*="sd|"] .datepicker').datepicker('option', 'beforeShowDay', function (date) {
          if (date >= startDate) return [true, '']

          return [false, '']
        })

        $('li[class*="sd|"] .datepicker').datepicker('option', 'showOtherMonths', true)

        $('li[class*="sd|"] .datepicker').on('click', function () {
          gotoDate($(this), (startDate.getMonth()), startDate.getFullYear())
        })
      }

      ////

      // Define an end date
      if ($('li[class*="ed|"] .datepicker').length) {
        var dateClass = $('li[class*="ed|"] .datepicker').parents('li[class*="ed|"]').attr('class'),
          _date = dateClass.match(/ed\|([^\s]*)/),
          endDate = new Date(_date[1])

        $('li[class*="ed|"] .datepicker').datepicker('option', 'beforeShowDay', function (date) {
          if (typeof startDate !== 'undefined' && startDate) {
            if (date >= startDate && date <= endDate) return [true, '']
          } else if (date <= endDate) {
            return [true, '']
          }

          return [false, '']
        })

        $('li[class*="ed|"] .datepicker').datepicker('option', 'showOtherMonths', true)
      }
      ////

      // disable saturdays along with di_gf_plus_xd
      function noSaturday (date) {
        var day = date.getDay(); return [(day != 6)]
      }

      // disable sundays along with di_gf_plus_xd
      function noSunday (date) {
        var day = date.getDay(); return [(day > 0), '']
      }

      // disable fridays along with di_gf_plus_xd
      function noFridayWeekend (date) {
        var day = date.getDay();
        if( (day == 5) || (day == 6)  || (day == 0) ){
          return [false, ''];
        }
        else
          return [true, ''];              
      }

      jQuery(window).on('di_gravity_forms_loaded', function() {

        // set first day of week to sunday
        if (jQuery('.gfield .datepicker').length) {
          jQuery('.gfield .datepicker').datepicker('option', 'firstDay', 0);
        }

        // add no translate to datepicker to prevent Google translate from working on it
        if (jQuery('#ui-datepicker-div').length) {
          jQuery('#ui-datepicker-div').addClass('notranslate')
        }

      });

      /*
       * eOF: Static classes for minDate
       */
      $(window).trigger('di_gravity_forms_loaded', ['bonobos'])
    }

    // Set the format of the datepicker dynamically depending on GF datepicker format setting used
    /* b/o: With all of the destructive Gravity Form datepicker classes above, we need to make sure we retain the correct date format for our system */
    /* This should work for both application.js and custom-bonobos.js datepickers */
    jQuery(window).on('di_gravity_forms_loaded', function(e, type) {
      var $gf_datepicker = (jQuery('.gfield .datepicker').length) ? jQuery('.gfield .datepicker') : false
      format = 'mm/dd/yy'

      if ($gf_datepicker) {
        if ($gf_datepicker.hasClass('mdy')) {
          format = 'mm/dd/yy'
        } else if ($gf_datepicker.hasClass('dmy')) {
          format = 'dd/mm/yy'
        } else if ($gf_datepicker.hasClass('dmy_dash')) {
          format = 'dd-mm-yy'
        } else if ($gf_datepicker.hasClass('dmy_dot')) {
          format = 'dd.mm.yy'
        } else if ($gf_datepicker.hasClass('ymd_slash')) {
          format = 'yy/mm/dd'
        } else if ($gf_datepicker.hasClass('ymd_dash')) {
          format = 'yy-mm-dd'
        } else if ($gf_datepicker.hasClass('ymd_dot')) {
          format = 'yy.mm.dd'
        }

        $gf_datepicker.datepicker('option', 'dateFormat', format)

        // Enable today
        if (jQuery('.gfield.di_gf_enable_today .datepicker').length > 0) {
          var todaysDate = new Date()
          // destroy default Gravity Form datepicker
          $('.gfield.di_gf_enable_today .datepicker').datepicker('option', 'minDate', todaysDate)
        }
        ////
      }
    });
    /* e/o: With all of the destructive Gravity Form datepicker classes above, we need to make sure we retain the correct date format for our system */
    /// /

    /**
     *
     * Add available Times for a testdrive
     * **************
     * If you edit anything in this feature, please make sure to update application.js with the same logic
     * **************
     * * Use the following classes on the form itself (wd = weekday from 8 to 7(19), we = weekend from 8 to 8(20)) use military time for closing time
     *        form_times_available wd|8-19 we|8-20
     * * Add a datepicker field with the following classes:
     *        datepicker available_date_time
     * * Add a dropdown/select field with the following class:
     *        available_time_slots
     */
        /**
         * Increment time by specified increments
         * @param  int start    a whole number from time start (following military time structure)
         * @param  int end      a whole number from time end (following military time structure)
         * @return array       an array
         */
    function getTimeIncrements (start, end, increments) {
      var availableTimes = []
      var open = parseInt(start)
      var close = parseInt(end)
      var timeOfDay = 'AM'
      var currentTime = open
      var inc = increments

      while (open <= close) {
              // convert military time to regular time
        if (open > 12) {
          currentTime = open - 12
          timeOfDay = 'PM'
        }

              // stops from selecting the end time (closing time), since they would close before getting a test drive in
        if (open != close) {
          jQuery.each(inc, function (i, val) {
            availableTimes.push(currentTime + ':' + val + ' ' + timeOfDay)
                  // console.log(currentTime + ":" + val + " " + timeOfDay);
          })
        }

        open++
        currentTime++
      }
      return availableTimes
    }

    jQuery('.available_date_time .datepicker').datepicker('option', 'onSelect', function (dateText, inst) {
      populateAvailableTimes(dateText)
    })

    if (jQuery('form.form_times_available').length) {
      populateAvailableTimes()
    }

    function populateAvailableTimes (dateText) {
      if (jQuery('form.form_times_available').length) {
        var timesFormClass = jQuery('form.form_times_available').attr('class')
        var formClasses = timesFormClass.split(' ')
        jQuery.each(formClasses, function (i, formClass) {
          if (formClass.match(/wd\|/i) != null) {
            weekdayTimes = formClass.replace(/wd\|/i, '').split('-')
            weekdayStart = weekdayTimes[0]
            weekdayEnd = weekdayTimes[1]
          } else if (formClass.match(/we\|/i) != null) {
            weekendTimes = formClass.replace(/we\|/i, '').split('-')
            weekendStart = weekendTimes[0]
            weekendEnd = weekendTimes[1]
          }
        })
      }

      if (typeof dateText === 'undefined') {
        dateText = jQuery('.available_date_time input[type=text]').val()
      }
      var dateSelected = new Date(dateText),
        _day = dateSelected.getDay(),
        dayOfWeek = null,
        timeIncrements = [15, 45]

      var weekdayTimes = {
        open: weekdayStart,
        closed: weekdayEnd
      }

      var weekendTimes = {
        open: weekendStart,
        closed: weekendEnd
      }

      switch (_day) {
        case 0:
          dayOfWeek = {
            day: 'Sunday',
            times: getTimeIncrements(weekendTimes.open, weekendTimes.closed, timeIncrements)
          }
          break
        case 1:
          dayOfWeek = {
            day: 'Monday',
            times: getTimeIncrements(weekdayTimes.open, weekdayTimes.closed, timeIncrements)
          }
          break
        case 2:
          dayOfWeek = {
            day: 'Tuesday',
            times: getTimeIncrements(weekdayTimes.open, weekdayTimes.closed, timeIncrements)
          }
          break
        case 3:
          dayOfWeek = {
            day: 'Wednesday',
            times: getTimeIncrements(weekdayTimes.open, weekdayTimes.closed, timeIncrements)
          }
          break
        case 4:
          dayOfWeek = {
            day: 'Thursday',
            times: getTimeIncrements(weekdayTimes.open, weekdayTimes.closed, timeIncrements)
          }
          break
        case 5:
          dayOfWeek = {
            day: 'Friday',
            times: getTimeIncrements(weekdayTimes.open, weekdayTimes.closed, timeIncrements)
          }
          break
        case 6:
          dayOfWeek = {
            day: 'Saturday',
            times: getTimeIncrements(weekendTimes.open, weekendTimes.closed, timeIncrements)
          }
          break
        default :
          dayOfTheWeek = null
      }

      if (jQuery('.available_time_slots select').length) {
        var $available_time_slots = jQuery('.available_time_slots select')
                // remove blank select values (if any)
        $available_time_slots.find('option:not(.gf_placeholder)').remove()

        if (dayOfWeek && dayOfWeek.times.length) {
                    // remove blank select values (if any)
          $available_time_slots.find('option:not(.gf_placeholder)').remove()
          jQuery.each(dayOfWeek.times, function (i, time) {
            $available_time_slots.append("<option class='available-time' value='" + time + "'>" + time + '</option>')
          })
        }
      }
    }
          /**
           *
           * e/o: Add available Times for a testdrive
           *
           */
  })

  /** *** MENUS *****/

  // Make sure dropdown doesn't extend past container edge
  //  ** to do: catch it on resizing the browser too

  function menuOverflow() {
    $('#menu-main-menu ul.sub-menu').each(function () { // Error "e is defined but never used from jsLint"
      var el = $(this);
      var off = el.offset();
      var l = off.left;
      var w = el.width();
      var $whitewrap = $('#whitewrap');
      var docW = $whitewrap.length ? $whitewrap.width() : $(window).width(); // Use window width as fallback
      var isEntirelyVisible = (l + w <= docW);
      if (!isEntirelyVisible) {
        el.addClass('edge');
      } else {
        el.removeClass('edge');
      }
    });
  } menuOverflow();

   // Vertical Menu Nav Edge
  jQuery('.vEdge').each(function () {
    var vEdgeParent = ''
    if ($('.dropdown-menu').length) {
      var vEdgeParent = '.dropdown-menu'
    } else {
      var vEdgeParent = '.sub-menu'
    }
    var vEdgeUl = jQuery(this).children(vEdgeParent)
    var vEdgeItemCount = vEdgeUl.children('li').length
    var vEdgeOffset = ((vEdgeItemCount - 1) * -100)
    var vEdgePerc = vEdgeOffset + '%'
    vEdgeUl.css('top', vEdgePerc)
  })
})

/* b/o: Format phone number on gravity forms on non-iphones ex: (555)555-1234 */
jQuery(document).ready(function ($) {
  if ($('.ginput_container_phone input[type=tel]').length && $(window).width() <= 1024) {
    $('.ginput_container_phone input[type=tel]').attr('onBlur', 'formatPhone(this)')
  }
})

function formatPhone (thisControl) {
  var strInitial = thisControl.value
  var strFinal = new String()
  var j = 0
  var rePhone = new RegExp('[(]\\d\\d\\d[)][ ]\\d\\d\\d[-]\\d{4}$')

  if (strInitial.length > 2) { strFinal = '(' }

  // Code for Remove starting 1
  strInitial = strInitial.replace(/[(]/g, '')
  strInitial = strInitial.replace(/[)]/g, '')
  strInitial = strInitial.replace(/-/g, '')

  strInitial = strInitial.replace('(1', '')
  while (strInitial.indexOf('1') == 0) {
    strInitial = strInitial.replace('1', '')
    while (strInitial.indexOf('-') == 0) {
      strInitial = strInitial.replace('-', '')
    }
  }

  // here we check for the already formatted phone number and exit if true
  if ((rePhone.test(strInitial) == true)) {
    return true
  }

  // here we begin processing the field, placing the numbers into a new phone number string
  for (var i = 0; i < strInitial.length; ++i) {
    if ((strInitial.charAt(i) == '0') || (strInitial.charAt(i) == '1') ||
        (strInitial.charAt(i) == '2') || (strInitial.charAt(i) == '3') ||
        (strInitial.charAt(i) == '4') || (strInitial.charAt(i) == '5') ||
        (strInitial.charAt(i) == '6') || (strInitial.charAt(i) == '7') ||
        (strInitial.charAt(i) == '8') || (strInitial.charAt(i) == '9')) {
      j = j + 1
      if (j == 4) {
        strFinal = strFinal + ') '
      }
      if (j == 7) {
        strFinal = strFinal + '-'
      }
      if (j < 11) {
        strFinal = strFinal + strInitial.charAt(i)
      }
    }
  }
  thisControl.value = strFinal
  if (strFinal.length == 1) {
    thisControl.value = ''
  }
  // here we check for an entry clearly too long or too short and flag it
  if ((strFinal.length != 14)) {
    return false
  } else {
    return true
  }
}
/* e/o: Format phone number on gravity forms on non-iphones ex: (555)555-1234 */
